import ViewReminders from "@swivu/shared-ui/src/components/ViewReminders.js";
import { useParams } from "react-router-dom";
import { useSettings } from "../hooks/useSettings.js";

const ViewRemindersPublic = () => {
  const { id, slug } = useParams<{ id: string; slug: string }>();
  const { timezone } = useSettings();
  return (
    <ViewReminders.Provider
      api="public"
      id={id as string}
      slug={slug as string}
      timezone={timezone}
    >
      <ViewReminders />
    </ViewReminders.Provider>
  );
};

export default ViewRemindersPublic;
